import { FormControl } from '@masterplandev/ui'

type PollControlProps = {
  children: React.ReactNode
  isSelected: boolean
}

export function PollControl({ children, isSelected }: PollControlProps) {
  return (
    <FormControl
      cursor="pointer"
      _hover={{ opacity: '100%' }}
      opacity={isSelected ? '100%' : '65%'}
      borderWidth="2px"
      borderStyle="solid"
      borderRadius="2xl"
      borderColor={isSelected ? 'mpGreen.base' : 'transparent'}
      px={{ xl: '10', lg: '8', md: '6', base: '4' }}
      pt={{ xl: '6', base: '4' }}
      pb={{ xl: '7', lg: '6', base: '5' }}
      rounded="md"
      bgColor={isSelected ? 'mpWhite.alpha8' : 'mpWhite.alpha4'}>
      {children}
    </FormControl>
  )
}
